import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { PermissionKey, PermissionScope } from "@fitness-app/data-models";

import { usePermission } from "~/hooks/usePermission";

const ProductRedirect = (): React.ReactElement => {
  const { id } = useParams();
  const canManageProducts = usePermission(PermissionKey.PRODUCTS_MANAGE, PermissionScope.ALL);

  return <Navigate to={`/products/${id}/${canManageProducts ? "details" : "resources"}`} replace />;
};

export default ProductRedirect;
